import React from 'react'
import { Link, hashHistory } from 'react-router'
import './_footer.scss'

const Footer = () => {

    return (
        <footer>
            100% of every click helps cure bad code.
        </footer>
    )
}

export default Footer


/** WEBPACK FOOTER **
 ** ./src/components/containers/footer/Footer.js
 **/